import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ProgressCircle from '../../../assets/icons/app/progress-circle.svg?raw';

export const ProgressCircleIcon = (props) => <CustomSVG svg={ProgressCircle} preserveColors appIconSmall {...props} />;
